// src/components/ProtectedRoute.tsx
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contaxt/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { checkAuthStatus } = useAuth();
  const location = useLocation();
  const [isValid, setIsValid] = useState<boolean | null>(null); // null = loading

  useEffect(() => {
    // Check token validity when route changes
    const status = checkAuthStatus();
    setIsValid(status);
  }, [location, checkAuthStatus]);

  if (isValid === null) {
    // Loading state while checking
    return <div>Loading...</div>;
  }

  if (!isValid) {
    // Redirect to login page, saving the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
